import axios from "axios";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuetify from "vuetify";
import auth from "./auth";
import VeeValidate, { Validator } from "vee-validate";
import ru from "vee-validate/dist/locale/ru";
import store from "./store";

import DataList from "./components/DataList.vue";
import DataListStateful from "./components/data-list/DataListStateful.vue";
import DataEditor from "./components/data-editor/DataEditor.vue";
import ReferenceList from "./components/reference/ReferenceList.vue";
import TinyReference from "./components/reference/TinyReference.vue";
import BooleanSelect from "./components/BooleanSelect.vue";
import DatePicker from "./components/date-picker/DatePicker.vue";
import DatePickerMultiple from "./components/date-picker/DatePickerMultiple.vue";
import Reference from "./components/reference/Reference.vue";
import ActionConfirm from "./components/ActionConfirm.vue";
import Loader from "./components/Loader.vue";
import DecimalEditor from "./components/text-fields/DecimalEditor.vue";
import Switch from "./components/Switch.vue";
import EditableStringList from "./components/EditableStringList.vue";
import MultipleReferenceCompact from "./components/reference/MultipleReferenceCompact.vue";
import EnumSelect from "./components/selection-field/EnumSelect.vue";
import DateRangePickerMultiple from "./components/date-picker/DateRangePickerMultiple.vue";
import DateRangePicker from "./components/date-picker/DateRangePicker.vue";
import LoadingPlaceModal from "./views/shippings/components/new-shipping/LoadingPlaceModal.vue";
import EditableList from "./components/EditableList.vue";
import ReferenceAddButton from "./components/reference/ReferenceAddButton.vue";
import TitleTextField from "./components/text-fields/TitleTextField.vue";
import MultipleEnumSelect from "./components/selection-field/MultipleEnumSelect.vue";
import MenuRowActions from "./components/MenuRowActions.vue";
import CurrencyReference from "./components/reference/CurrencyReference.vue";
import OnReconstruction from "./components/OnReconstruction.vue";
import PlanFactDates from "./components/PlanFactDates.vue";
import SaveBtn from "./components/SaveBtn.vue";
import CancelBtn from "./components/CancelBtn.vue";
import ManagerSelect from "./components/selection-field/ManagerSelect.vue";
import AddressSelect from "./components/selection-field/AddressSelect.vue";
import DownloadXlsxBtn from "./components/DownloadXlsxBtn.vue";
import ReferenceMultipleSelect from "./components/reference/ReferenceMultipleSelect.vue";

import "vuetify/dist/vuetify.min.css";

Vue.config.productionTip = false;

Vue.use(Vuetify);

Vue.use(VeeValidate);
Validator.localize("ru", ru);

import { Plugin } from "vue-fragment";
Vue.use(Plugin);

Vue.config.errorHandler = (err, vm) => {
  if (err.message) {
    console.log(err);
    const message = err.status == 500 ? err.message : "Ошибка приложения";
    vm.$root.showError(message);
    callInAllComponents({ method: "resetLoaders", component: vm.$root });
  } else {
    return Promise.reject(err);
  }

  function callInAllComponents(value) {
    if (value.component[value.method]) {
      value.component[value.method]();
    }
    if (value.component?.$children) {
      value.component.$children.forEach(c =>
        callInAllComponents({ method: "resetLoaders", component: c }),
      );
    }
  }
};

Vue.component("app-data-list", DataList);
Vue.component("DataListStateful", DataListStateful);
Vue.component("app-data-editor", DataEditor);
Vue.component("app-reference-list", ReferenceList);
Vue.component("app-tiny-reference", TinyReference);
Vue.component("app-boolean-select", BooleanSelect);
Vue.component("app-date-picker", DatePicker);
Vue.component("app-date-picker-multiple", DatePickerMultiple);
Vue.component("app-reference", Reference);
Vue.component("app-action-confirm", ActionConfirm);
Vue.component("app-loader", Loader);
Vue.component("DecimalEditor", DecimalEditor);
Vue.component("app-switch", Switch);
Vue.component("EditableStringList", EditableStringList);
Vue.component("MultipleReferenceCompact", MultipleReferenceCompact);
Vue.component("EnumSelect", EnumSelect);
Vue.component("DateRangePickerMultiple", DateRangePickerMultiple);
Vue.component("DateRangePicker", DateRangePicker);
Vue.component("LoadingPlaceModal", LoadingPlaceModal);
Vue.component("EditableList", EditableList);
Vue.component("ReferenceAddButton", ReferenceAddButton);
Vue.component("TitleTextField", TitleTextField);
Vue.component("MultipleEnumSelect", MultipleEnumSelect);
Vue.component("MenuRowActions", MenuRowActions);
Vue.component("CurrencyReference", CurrencyReference);
Vue.component("OnReconstruction", OnReconstruction);
Vue.component("PlanFactDates", PlanFactDates);
Vue.component("SaveBtn", SaveBtn);
Vue.component("CancelBtn", CancelBtn);
Vue.component("ManagerSelect", ManagerSelect);
Vue.component("AddressSelect", AddressSelect);
Vue.component("DownloadXlsxBtn", DownloadXlsxBtn);
Vue.component("ReferenceMultipleSelect", ReferenceMultipleSelect);

import Office from "./views/offices/Office.vue";
import Position from "./views/positions/Position.vue";
import Country from "./views/countries/Country.vue";
import ActivityType from "./views/activity-types/ActivityType.vue";
import Currency from "./views/currencies/Currency.vue";
import Employee from "./views/employees/Employee.vue";
import Region from "./views/regions/Region.vue";
import City from "./views/cities/City.vue";
import Address from "./views/addresses/Address.vue";
import Warehouse from "./views/warehouses/Warehouse.vue";
import Client from "./views/clients/Client.vue";
import RollingStockType from "./views/rolling-stock-types/RollingStockType.vue";
import Factory from "./views/factories/Factory.vue";
import Manufacturer from "./views/manufacturers/Manufacturer.vue";
import ContactPerson from "./views/contact-persons/ContactPerson.vue";
import Carrier from "./views/carriers/Carrier.vue";
import Vehicle from "./views/vehicles/Vehicle.vue";
import Driver from "./views/drivers/Driver.vue";
import RollingStock from "./views/rolling-stocks/RollingStock.vue";
import ProductCategory from "./views/product-categories/ProductCategory.vue";
import User from "./views/users/User.vue";
import Unit from "./views/units/Unit.vue";
import Trademark from "./views/trademarks/Trademark.vue";
import TrademarkModel from "./views/trademark-models/TrademarkModel.vue";
import Nomenclature from "./views/nomenclatures/Nomenclature.vue";
import Article from "./views/articles/Article.vue";
import Forwarder from "./views/forwarders/Forwarder.vue";
import District from "./views/districts/District.vue";
import GoodsType from "./views/goods-types/GoodsType.vue";
import CourierService from "./views/courier-service/CourierService.vue";

Vue.component("Office", Office);
Vue.component("Position", Position);
Vue.component("Country", Country);
Vue.component("ActivityType", ActivityType);
Vue.component("Currency", Currency);
Vue.component("Employee", Employee);
Vue.component("Region", Region);
Vue.component("City", City);
Vue.component("Address", Address);
Vue.component("Warehouse", Warehouse);
Vue.component("Client", Client);
Vue.component("RollingStockType", RollingStockType);
Vue.component("Factory", Factory);
Vue.component("Manufacturer", Manufacturer);
Vue.component("ContactPerson", ContactPerson);
Vue.component("Carrier", Carrier);
Vue.component("Vehicle", Vehicle);
Vue.component("Driver", Driver);
Vue.component("RollingStock", RollingStock);
Vue.component("ProductCategory", ProductCategory);
Vue.component("User", User);
Vue.component("Unit", Unit);
Vue.component("Trademark", Trademark);
Vue.component("TrademarkModel", TrademarkModel);
Vue.component("Nomenclature", Nomenclature);
Vue.component("Article", Article);
Vue.component("Forwarder", Forwarder);
Vue.component("District", District);
Vue.component("GoodsType", GoodsType);
Vue.component("CourierService", CourierService);

Vue.mixin({
  data() {
    return {
      get moment() {
        return require("moment");
      },
      get lodash() {
        return require("lodash");
      },
    };
  },
  methods: {
    showInfo(message) {
      const appComponent = this.$root.$children[0];
      appComponent.showInfo(message);
    },
    showError(message) {
      const appComponent = this.$root.$children[0];
      appComponent.showError(message);
    },
  },
});

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

http.interceptors.request.use(
  function(config) {
    config.headers["Authorization"] = "Bearer " + auth.getToken();
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

router.beforeEach((to, from, next) => {
  if (to != from) {
    localStorage.removeItem("page");
    localStorage.removeItem("sort");
    localStorage.removeItem("filter");
    localStorage.removeItem("quickFilter");
    localStorage.removeItem("settings");
  }
  const title = process.env.VUE_APP_TITLE;
  document.title = `${title ? title : "Logistics"} ${
    to.meta.title ? " | " + to.meta.title : ""
  }`;

  if (
    to.matched.some(record => record.meta.requiresAuth && record.path !== "/")
  ) {
    if (!auth.loggedIn()) {
      next({
        path: "/",
        query: { redirect: to.fullPath },
      });
    } else if (auth.tokenIsExpired()) {
      const refreshTokenRequestSettings = {
        url: "/token",
        method: "post",
        data: `grant_type=refresh_token&refresh_token=${auth.getRefreshToken()}`,
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      };
      const refreshPromise = http(refreshTokenRequestSettings)
        .then(res => {
          auth.login(
            res.data.access_token,
            res.data.refresh_token,
            res.data.expires_in,
          );
          next();
        })
        .catch(function(err) {
          console.log(err);
          auth.logout();
          window.location = "/";
          return;
        });

      return Promise.resolve(refreshPromise);
    } else {
      next();
    }
  } else {
    next();
  }
});

http.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    const appComponent = vue.$root.$children[0];
    if (err.response.status == 401 && err.config._retry !== true) {
      err.config._retry = true;

      const refreshTokenRequestSettings = {
        url: "/token",
        method: "post",
        data: `grant_type=refresh_token&refresh_token=${auth.getRefreshToken()}`,
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      };
      const refreshPromise = http(refreshTokenRequestSettings)
        .then(res => {
          auth.login(
            res.data.access_token,
            res.data.refresh_token,
            res.data.expires_in,
          );
          err.config.headers.Authorization = res.data.refresh_token;
          return http(err.config);
        })
        .catch(function(err) {
          console.log(err);
          auth.logout();
          window.location = "/";
          return;
        });

      return Promise.resolve(refreshPromise);
    } else if (err.response) {
      let message = err.response.status;
      if (err.response.data.ModelState) {
        for (const errorProperty in err.response.data.ModelState) {
          err.response.data.ModelState[errorProperty].forEach(
            m => (message += "\n" + m),
          );
        }
      } else if (err.response.data.error_description) {
        message += "\n" + err.response.data.error_description;
      } else if (err.response.data.ExceptionMessage) {
        message += " " + err.response.data.ExceptionMessage;
      } else if (err.response.data.Message) {
        message += " " + err.response.data.Message;
      } else if (typeof err.response.data === "string") {
        message += " " + err.response.data;
      }
      appComponent.showError(message);
      return Promise.reject(err.response);
    } else {
      appComponent.showError(err.Message);
      return Promise.reject(err);
    }
  },
);

Vue.prototype.$http = http;

Vue.filter("dateTime", function(value) {
  if (!value) {
    return "";
  }

  const moment = require("moment");
  const date = moment(value);
  if (date.isValid()) {
    return date.format("DD.MM.YY HH:mm");
  }
  return "";
});

Vue.filter("date", function(value) {
  const moment = require("moment");
  const date = moment(value);
  if (date.isValid()) {
    return date.format("DD.MM.YY");
  }
  return "";
});

Vue.filter("time", function(value) {
  const moment = require("moment");
  const date = moment(value);
  if (date.isValid()) {
    return date.format("HH:mm");
  }
  return "";
});

Vue.filter("cropText", function(value, limit) {
  if (value.length > limit) {
    return value.substring(0, limit) + "...";
  }
  return value;
});

Vue.filter("dateRange", function(value) {
  const date = {
    from: value.From || value.from || value.dateFrom,
    to: value.To || value.to || value.dateTo,
  };
  const moment = require("moment");
  if (date && date.from !== date.to) {
    return `${moment(date.from).format("DD.MM.YY")} - ${moment(date.to).format(
      "DD.MM.YY",
    )}`;
  } else if (date && date.from === date.to) {
    return moment(date.from).format("DD.MM.YY");
  } else {
    return "";
  }
});

Vue.filter("emailMask", function(value) {
  var fieldValue = value;
  let changeIndex = false;
  const fieldValueParts = fieldValue.split("@");

  if (fieldValue !== "") {
    if (!~fieldValue.indexOf("@")) {
      fieldValue = `${fieldValue}@`;
      changeIndex = true;
    } else if (
      ~fieldValue.indexOf("@") &&
      fieldValueParts.length > 1 &&
      !~fieldValueParts[1].lastIndexOf(".") &&
      fieldValueParts.length > 1 &&
      fieldValueParts[1].length > 0
    ) {
      fieldValue = `${fieldValue}.`;
      changeIndex = true;
    }
  }

  if (fieldValue.length === 1 && ~fieldValue.indexOf("@")) {
    fieldValue = "";
  }

  if (
    fieldValueParts.length === 2 &&
    fieldValueParts[1].length === 1 &&
    ~fieldValueParts[1].indexOf(".")
  ) {
    fieldValue = fieldValue.replace(/(\s+)?.$/, "");
  }

  return { value: fieldValue, changeIndex };
});

Vue.filter("shortName", function(value) {
  if (value) {
    const formatingValue = value.replace(/ +/g, " ").trim();
    const arrOfValues = formatingValue.split(" ", 2);
    const shortName =
      arrOfValues.length > 1
        ? `${arrOfValues[0]} ${arrOfValues[1][0]}.`
        : arrOfValues[0];
    return shortName;
  } else {
    return "";
  }
});

Vue.filter("separateDigits", function(value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(\D|$))/g, "$1 ");
});

Vue.filter("fixedNumber", (value, scale) => {
  if (!isNaN(value) && typeof value === "number") {
    return value.toFixed(scale).replace(".", ",");
  } else {
    return "";
  }
});

Vue.filter("phoneInternational", function(value) {
  return value.replace(
    /(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/,
    "+$1($2)$3-$4-$5",
  );
});

Vue.filter("phoneInternal", value => {
  if (value.length > 12) {
    return `+${value.slice(0, 12)} *${value.slice(12)}`;
  } else {
    return `+${value}`;
  }
});

Vue.filter("stringList", (value, dictinct = false, dataTitle = "title") => {
  if (!Array.isArray(value)) {
    return "";
  }
  let stringList = value.map(i => {
    if (i && typeof i === "object") {
      return Object.prototype.hasOwnProperty.call(i, dataTitle)
        ? i[dataTitle]
        : "";
    } else if (i && typeof i === "string") {
      return i;
    } else {
      return "";
    }
  });
  if (dictinct) {
    stringList = stringList.filter(
      (str, index, arr) => arr.indexOf(str) == index,
    );
  }
  return stringList.join("; ");
});

Vue.filter("trimSpaces", value => {
  if (!value) {
    return;
  }
  return value.replace(/\s+/g, " ").trim();
});

const vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");

export { vue };
